<template>
  <div>
    <div class="two-title">
      <span v-for="(item,index) in titleData2"
        :key="index">{{item}}</span>
    </div>
    <!--<div>-->
    <!--{{contentData}}-->
    <!--</div>-->
    <ul class="order_content">
      <li @click="linkDeatil(item)"
        v-for="(item,index) in arrData"
        :key="index">
        <span class="targetId">{{getTarget(item)}}</span>
        <span :class="{'latestPrice-up':item.latestPrice>item.lastSettlementPrice,'latestPrice-down':item.latestPrice<item.lastSettlementPrice}">{{item.latestPrice}}</span>
        <span>{{item.volume}}</span>
        <!-- <span>
          <i @click="changeShowData"
            :class="{'background-grey':item.latestPrice==item.lastSettlementPrice,'background-red':item.latestPrice>item.lastSettlementPrice,'background-green':item.latestPrice<item.lastSettlementPrice}"
            class="li-three-span"> {{percent?((item.latestPrice-item.lastSettlementPrice)*100/item.lastSettlementPrice).toFixed(2)+'%':(item.latestPrice-item.lastSettlementPrice > 0?'+' + (item.latestPrice-item.lastSettlementPrice).toFixed(0):(item.latestPrice-item.lastSettlementPrice).toFixed(0))}}</i>
        </span> -->
        <span>
          <i @click="changeShowData"
            :class="{'background-grey':item.latestPrice==item.lastSettlementPrice,'background-red':item.latestPrice>item.lastSettlementPrice,'background-green':item.latestPrice<item.lastSettlementPrice}"
            class="li-three-span"> {{percent?item.rangeRate: item.range}}</i>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "tradeList",
  props: ["contentData"],
  data() {
    return {
      titleData2: ["合约", "最新价", "成交量", "涨跌幅"],
      percent: true,
    };
  },
  computed:{
    arrData: function() {
      var arrDatas = [];
      for(const i of this.contentData) {
        if (i.lastSettlementPrice == 0) {
          var temporary = '0.00%'
        } else {
          var temporary = ((i.latestPrice-i.lastSettlementPrice)*100/i.lastSettlementPrice).toFixed(2)+'%';
        }
        arrDatas.push({
          lastSettlementPrice: i.lastSettlementPrice,
          latestPrice: i.latestPrice,
          targetId: i.targetId,
          targetName: i.targetName,
          volume: i.volume,
          rangeRate: temporary,
          range: (i.latestPrice-i.lastSettlementPrice > 0?'+' + (i.latestPrice-i.lastSettlementPrice).toFixed(0):(i.latestPrice-i.lastSettlementPrice).toFixed(0))
        })
      }
      return arrDatas;
    }
  },
  mounted() {
    // console.log(this.arrData);
  },
  methods: {
    getTarget(item) {
      // return item.targetName.length <= 7 ? item.targetName : item.targetId;
     return item.targetName;
    },
    linkDeatil(item) {
      // this.$router.push({path:'/marketDetail/'+contract});
      this.$router.push({ path: "/marketDetail/" + item.targetId });
      // this.$router.push({path:'/marketDeatil'});
    },
    changeShowData(e) {
      e.stopPropagation();
      this.percent = !this.percent;
      if (this.percent == true) {
        this.titleData2[3] = "涨跌幅";
      } else if (this.percent == false) {
        this.titleData2[3] = "涨跌";
      }
    }
  }
};
</script>

<style scoped>
.two-title {
  /*width: 7.5rem;*/
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.3rem;
  color: #f5f9fc;
  /*background: #1F1F1F;*/
  background: #161712;
  display: flex;
  justify-content: center;
  flex-direction: row;
  /*position: relative;*/
}

.two-title span {
  width: 25%;
  display: inline-block;
  text-align: center;
}

.two-title span:nth-child(1)
{
  width: 35%;
}

ul {
  width: 7.5rem;
  background: #1f1f1f;
}

li {
  line-height: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-size: 0.3rem;
  color: #a0a4a7;
  /*border-bottom: 1px solid #dedede;*/
  /*font-weight: bold;*/
  position: relative;
}

li::after {
  content: "  ";
  position: absolute;
  left: 0;
  top: 1rem;
  width: 100%;
  height: 1px;
  background-color: #444;
  /*background-color: #202228;*/
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleY(0.1);
  transform: scaleY(0.1);
}

li span {
  display: inline-block;
  width: 25%;
  text-align: center;
  overflow: hidden;
}

li span:nth-child(1)
{
  width: 35%;
}

.order_content {
  width: 100%;
  position: absolute;
  top: 2rem;
  bottom: 1rem;
  overflow: scroll;

  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.targetId {
  color: #d8b830;
  /*color:#A57518;*/
}

.latestPrice-up {
  /*color:#DE071D;*/
  color: #ff0000;
}

.latestPrice-down {
  /*color:#23D51F;*/
  color: #008000;
}

.background-grey {
  background: #a0a0a0;
}

.background-red {
  background: #ff0000;
}

.background-green {
  background: #008000;
}

.li-three-span {
  border-radius: 3px;
  height: 0.6rem;
  text-align: center;
  display: inline-block;
  font-style: normal;
  line-height: 0.6rem;
  width: 85%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tradeList.vue